import { useMutation } from 'react-query';
import axios from 'axios';
import { TerminalAppearanceAPI } from '../../../constants/API';
import { queryClient } from '../../../queryClient';
import { commonHeaders } from '../../../constants/HeadersAPI';
import { useContext } from 'react';
import { AlertContext } from '../../../context/AlertProvider';
import { AlertType } from '../../../types/enums';
import { defaultSuccessMessage } from '../../../constants/alertText';

export const useDeleteTerminalChildrenBackground = () => {
  const context = useContext(AlertContext);

  const {
    mutate: deleteTerminalChildrenBackground,
    isLoading: isDeleteTerminalChildrenBackgroundLoading
  } = useMutation(
    ['TerminalAppearanceDeleteChildrenBackground'],
    (backgroundId: number) =>
      axios.delete(
        TerminalAppearanceAPI.deleteChildrenBackground(backgroundId),
        commonHeaders()
      ),
    {
      onSuccess: () => {
        queryClient
          .invalidateQueries('TerminalAppearance')
          .then(() =>
            context?.setAlert({ type: AlertType.Success, message: defaultSuccessMessage })
          );
      }
    }
  );

  return { deleteTerminalChildrenBackground, isDeleteTerminalChildrenBackgroundLoading };
};
